export class Sensor {
  id: number;
  officeId: number;
  relayBoardId: number;
  sensorId: number;
  name: string;

  public constructor(init?: Partial<Sensor>) {
    Object.assign(this, init);
  }
}
